import { render, staticRenderFns } from "./ReleasePreview.vue?vue&type=template&id=e0c490fe&scoped=true&"
import script from "./ReleasePreview.vue?vue&type=script&lang=js&"
export * from "./ReleasePreview.vue?vue&type=script&lang=js&"
import style0 from "./ReleasePreview.vue?vue&type=style&index=0&id=e0c490fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c490fe",
  null
  
)

export default component.exports